import { wgs2gcjForObject, isEqual } from '@/util/map'
import { datetime } from '@/util'
import carTrack from '@/views/car/track/index'
import { geocoder, latlngFromObject } from '@/components/sl-amap/utils'

import './index.scss'

export default {
  props: [ 'carNo' ,'location', 'visible' , 'showClose' ],

  data(){
    return {
      data:null,
      address:null,
      status:{}
    }
  },
  created(){
    this.$watch('carNo' , function(nv){
      if(nv){
        this.query()
      }
    } , {immediate:true})
  },
  methods:{
    query() {
      this.$request.car(this.carNo).then(resp => {
        this.$utils.valid(resp.data, {
          location: {},
          status: {},
          company: {}
        })

        this.data = resp.data

      })
    },

    handleClose(){
      this.$emit('close')
    },
    close(){
      this.$emit('close')
    }
  },
  render() {
    const currentData = this.data || {status:{} , insurance:{}, company:{} , license:{} , location:{}}
    let visible = !!this.carNo
    return (
      <div class={{"map-car-detail":true,"map-car-detail--visible":visible}}>
        <div class="map-car-detail__header">
          {
            this.showClose ? <div class="map-car-detail__close" on-click={this.handleClose}><Icon size={18} type="md-close" /></div> : null
          }
          
          <div class="map-car-detail__title">{currentData.company.companyName}</div>
          <p>No. {currentData.carNo} <span style="margin-left: 5em;"></span></p>
        </div>
        <div class="map-car-detail__body">
          <sl-detail-list item-style={{'marginBottom':'8px'}} label-width="80px" col={1} label-align="right">
            <sl-detail-list-item label="所属网点">{currentData.company.companyName}</sl-detail-list-item>
            <sl-detail-list-item label="快递品牌">{currentData.company.brandName}</sl-detail-list-item>
            <sl-detail-list-item label="车辆编号">{currentData.carNo}</sl-detail-list-item>
            <sl-detail-list-item label="车牌号">{currentData.licenseNo}</sl-detail-list-item>
            <sl-detail-list-item label="车架号">{currentData.frameNo}</sl-detail-list-item>
            <sl-detail-list-item label="IMEI">{currentData.imei}</sl-detail-list-item>
            <sl-detail-list-item label="保单号">{currentData.insurance.insuranceNo || '' }</sl-detail-list-item>
            <sl-detail-list-item label="照片">
              {
                currentData.photo ? <sl-carousel images={currentData.photo.split(';')} /> : null
              }
            </sl-detail-list-item>
          </sl-detail-list>
        </div>
      </div>
    )
  }
}